// Libraries
import * as React from 'react';
import { observer } from 'mobx-react';
import * as classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';

// Components
import { LoadingSpinner } from '.';

// Styles
require('./LoadingFullScreen.css');
const c = 'comp-loading-pane';

// Props
interface ILoadingFullScreenProps {
    className?: string | null;
    spinnerClassName?: string | null;
    active: boolean;
    fitInContainer?: boolean;
}

// Component
@observer
export class LoadingFullScreen extends React.Component <ILoadingFullScreenProps, {} > {
    public static defaultProps: ILoadingFullScreenProps = {
        className: null,
        spinnerClassName: null,
        active: false,
        fitInContainer: false,
    };

    constructor() {
        super();
    }

    public render() {
        return (
            <CSSTransitionGroup
                component="div"
                className={`${c}-container`}
                transitionName="fade"
                transitionAppear={true}
                transitionAppearTimeout={300}
                transitionEnter={true}
                transitionEnterTimeout={300}
                transitionLeave={false}
                transitionLeaveTimeout={0}
            >
                {this.props.active && (
                    <div
                        className={classNames(c, this.props.className, {
                            [`${c}-fit`]: this.props.fitInContainer,
                        })}
                    >
                        <LoadingSpinner
                            key="spinner"
                            active={true}
                            className={this.props.spinnerClassName ? this.props.spinnerClassName : undefined}
                        />
                    </div>
                )}
            </CSSTransitionGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/indicator/LoadingFullScreen.tsx